import type { IFilterPanelBaseFilterDeps } from "../types/filters";

import { FilterPanelBaseFilter } from "./BaseFilter";

export default abstract class ExcludeFilter<
    DTOValue,
    O = readonly string[],
    LocalValue = DTOValue | undefined,
> extends FilterPanelBaseFilter<DTOValue, O, LocalValue> {
    protected constructor(deps: IFilterPanelBaseFilterDeps<DTOValue, O>) {
        super(deps);
    }

    abstract getFullSelection(): LocalValue;
}
